import { type TaskInfoDto } from '@/app/models/TaskInfoDto';
import { useDownloadTaskFile } from '../core/_hooks';

type Props = { task: TaskInfoDto<string> };

/**
 * Aviso de que o arquivo ficou pronto fora do modal. O download é do usuário (botão): sem gesto o navegador
 * pode bloquear, e ele já está em outra tela.
 */
const TaskReadyToast = ({ task }: Props) => {
  const download = useDownloadTaskFile();

  return (
    <div className="d-flex align-items-center gap-3 flex-grow-1" style={{ minWidth: 0 }}>
      <div className="flex-grow-1 overflow-hidden">
        <div className="fw-bold text-gray-900">Exportação pronta</div>
        <div className="fs-7 text-gray-600 text-truncate">
          {[task.title ?? task.name, task.detail].filter(Boolean).join(' · ')}
        </div>
      </div>
      <button
        className="btn btn-sm btn-primary text-nowrap flex-shrink-0"
        disabled={download.isPending}
        type="button"
        onClick={() => download.mutate(task)}
      >
        Baixar
      </button>
    </div>
  );
};

export default TaskReadyToast;
